// For legacy block support
// import 'slick-carousel';
// import initFeatherlight from 'featherlight'
// initFeatherlight();
import './legacy-blocks';

import './blog';
import './navigation';
import './responsive-spacers';
import './search';
import './fslightbox-3.6.0';
import htmx from 'htmx.org';
import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';

htmx.config.globalViewTransitions = true;

window.Alpine = Alpine;
Alpine.start();

window.Splide = Splide;

document.addEventListener('DOMContentLoaded', function () {
    const galleryToggle = document.getElementById('gallery-toggle');
    if (galleryToggle) {
        const productGallery = new window.FsLightbox();
        productGallery.props.sources = window.productImages || [];
        productGallery.props.thumbs = window.productGalleryThumbs || [];
        productGallery.props.showThumbsOnMount = true;
        refreshFsLightbox();

        galleryToggle.addEventListener('click', (event) => {
            event.preventDefault();
            productGallery.open();
        });
    }

    const productCategorySlider = document.querySelector('.splide.product-category-slider');
    if (productCategorySlider) {
        new Splide(productCategorySlider, {
            type: 'loop',
            rewind: true,
            perPage: 1,
            perMove: 1,
            pagination: false,
            mediaQuery: 'min',
            padding: {left: '7%', right: '7%'},
            gap: '10%',
            breakpoints: {
                630: {
                    perMove: 2,
                    perPage: 2,
                    gap: '20px',
                },
                1024: {
                    destroy: true
                }
            }
        }).mount();
    }
});
